/**
 * jquery.dlmenu.js v1.0.1 - modified for defa backbone marionette app (simplify)
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
import { defa } from 'defa-object';

( function( $, window ) {
	// global
	let Modernizr = window.Modernizr;

	$.DLMenu = function( options, element ) {
		this.$el = $( element );
		this._init( options );
	};

	// the options
	$.DLMenu.defaults = {
		
		// classes for the animation effects
		animationClasses : {
			classin : 'dl-animate-in',
			classout : 'dl-animate-out',
		},
		
		// callback: click a link that has a sub menu
		// el is the link element (li); name is the level name
		onLevelClick : function( /* el, name */ ) {
			return false;
		},
		
		// callback: click a link that does not have a sub menu
		// el is the link element (li); ev is the event obj
		onLinkClick : function( /* el, ev */ ) {
			return false;
		}
	};

	$.DLMenu.prototype = {
		_init : function( options ) {

			// options
			this.options = $.extend( true, {}, $.DLMenu.defaults, options );
			// cache some elements and initialize some variables
			this._config();
			
			let animEndEventNames = {
					'WebkitAnimation' : 'webkitAnimationEnd',
					'OAnimation' : 'oAnimationEnd',
					'msAnimation' : 'MSAnimationEnd',
					'animation' : 'animationend'
				},
				
				transEndEventNames = {
					'WebkitTransition' : 'webkitTransitionEnd',
					'MozTransition' : 'transitionend',
					'OTransition' : 'oTransitionEnd',
					'msTransition' : 'MSTransitionEnd',
					'transition' : 'transitionend'
				};
			// animation end event name
			this.animEndEventName = animEndEventNames[ Modernizr.prefixed( 'animation' ) ] + '.dlmenu';
			// transition end event name
			this.transEndEventName = transEndEventNames[ Modernizr.prefixed( 'transition' ) ] + '.dlmenu';
			// support for css animations and css transitions
			this.supportAnimations = true;//Modernizr.cssanimations, / caniuse reports everyone has this.
			this.supportTransitions = true;//Modernizr.csstransitions;
			
			this._initEvents();

		},
		_config : function() {
			this.open = false;
			this.$trigger = this.$el.children( '.dl-trigger' );
			this.$menu = this.$el.children( 'ul.dl-menu' );
			this.$menuitems = this.$menu.find( 'li:not(.dl-back)' );
			this.$el.find( 'ul.dl-submenu' ).prepend( '<li class="dl-back"><a href="#" aria-label="Back">&laquo;</a></li>' );
			this.$back = this.$menu.find( 'li.dl-back' );
		},
		
		_initEvents : function() {
			let self = this;

			this.$trigger.on( 'click.dlmenu', function() {
				
				// added kill language menu for defa.
				if ( defa.objects.languageSelector ) {
					defa.objects.languageSelector.closeMenu();
				}
			
				if( self.open ) {
					self._closeMenu();
				} else {
					self._openMenu();
				}
				return false;

			} );

			this.$menuitems.on( 'click.dlmenu', function( event ) {
				event.stopPropagation();

				let $item = $(this),
					$submenu = $item.children( 'ul.dl-submenu' );

				if( $submenu.length > 0 ) {

					let $flyin = $submenu.clone().css( 'opacity', 0 ).insertAfter( self.$menu ),
						onAnimationEndFn = function() {
							self.$menu.off( self.animEndEventName ).removeClass( self.options.animationClasses.classout ).addClass( 'dl-subview' );
							$item.addClass( 'dl-subviewopen' ).parents( '.dl-subviewopen:first' ).removeClass( 'dl-subviewopen' ).addClass( 'dl-subview' );
							$flyin.remove();
						};

					setTimeout( function() {
						$flyin.addClass( self.options.animationClasses.classin );
						self.$menu.addClass( self.options.animationClasses.classout );
						if( self.supportAnimations ) {
							self.$menu.on( self.animEndEventName, onAnimationEndFn );
						} else {
							onAnimationEndFn.call();
						}

						self.options.onLevelClick( $item, $item.children( 'a:first' ).text() );
					} );

					return false;

				} else {
				
					
				
				
					// - Backbone History Hotfix

					let href = { prop: $( event.target ).prop( 'href' ), attr: $( event.target ).attr( 'href' ) },
					    root = location.protocol + '//' + location.host + Bb.history.options.root;
					
					/* debug 
					event.preventDefault();
					// you may log href and root to debug links
					
					/**/
					
					// added kill language menu for defa.
					if ( defa.objects.languageSelector ) {
						defa.objects.languageSelector.closeMenu();
					}
					
					
					if ( href.prop && href.prop.slice( 0, root.length ) === root ) {
						event.preventDefault();
						Bb.history.navigate( href.attr, true );

						// close menu
						self.closeMenu();
					} else {
						self.options.onLinkClick( $item, event );
					}

					// end Backbone History Hotfix

				}

			} );

			this.$back.on( 'click.dlmenu', function( /* event */ ) {
				
				let $this = $( this ),
					$submenu = $this.parents( 'ul.dl-submenu:first' ),
					$item = $submenu.parent(),

					$flyin = $submenu.clone().insertAfter( self.$menu );

				let onAnimationEndFn = function() {
					self.$menu.off( self.animEndEventName ).removeClass( self.options.animationClasses.classin );
					$flyin.remove();
				};

				setTimeout( function() {
					$flyin.addClass( self.options.animationClasses.classout );
					self.$menu.addClass( self.options.animationClasses.classin );
					if( self.supportAnimations ) {
						self.$menu.on( self.animEndEventName, onAnimationEndFn );
					} else {
						onAnimationEndFn.call();
					}

					$item.removeClass( 'dl-subviewopen' );
					
					let $subview = $this.parents( '.dl-subview:first' );
					if( $subview.is( 'li' ) ) {
						$subview.addClass( 'dl-subviewopen' );
					}
					$subview.removeClass( 'dl-subview' );
				} );

				return false;

			} );
			
		},
		closeMenu : function() {
			if( this.open ) {
				this._closeMenu();
			}
		},
		_closeMenu : function() {
			let self = this,
				onTransitionEndFn = function() {
					self.$menu.off( self.transEndEventName );
					self._resetMenu();
				};
			$( window ).off( 'touchend.outsideMenu click.outsideMenu' );
			
			this.$menu.removeClass( 'dl-menuopen' );
			this.$menu.addClass( 'dl-menu-toggle' );
			this.$trigger.removeClass( 'dl-active' );
			
			if( this.supportTransitions ) {
				this.$menu.on( this.transEndEventName, onTransitionEndFn );
			} else {
				onTransitionEndFn.call();
			}

			this.open = false;
			
		},
		openMenu : function() {
			if( !this.open ) {
				this._openMenu();
			}
		},
		_openMenu : function() {
			let self = this;
			
			// add touch controller to close the support frame as soon as the animation is done.
			_.delay( function() {
				$( window ).on( 'touchend.outsideMenu click.outsideMenu', function( event ) {
					// only trigger on touches and clicks outside the support frame
					if ( ! self.$el.is( event.target ) && 0 === self.$el.has( event.target ).length ) {
						//self.hideSupportFrame();
						self._closeMenu();
					}
				});
			}, 300 );
			
			
			// Let's open the menu!
			this.$menu.addClass( 'block' );

			setTimeout( function() {
			
				self.$menu.addClass( 'dl-menuopen dl-menu-toggle' ).on( self.transEndEventName, function() {
					self.$menu.removeClass( 'dl-menu-toggle' );
				});
				self.$trigger.addClass( 'dl-active' );
				self.open = true;

			}, 20 );

			// the menu is now opened!
		},
		// resets the menu to its original state (first level of options)
		_resetMenu : function() {
			this.$menu.removeClass( 'dl-subview' );
			this.$menuitems.removeClass( 'dl-subview dl-subviewopen' );
		}
	};

	$.fn.dlmenu = function( options ) {
		if ( 'string' === typeof options ) {
			let args = Array.prototype.slice.call( arguments, 1 );
			this.each(function() {
				let instance = $.data( this, 'dlmenu' );
				instance[ options ].apply( instance, args );
			});
		} else {
			this.each(function() {	
				let instance = $.data( this, 'dlmenu' );
				if ( instance ) {
					instance._init();
				} else {
					instance = $.data( this, 'dlmenu', new $.DLMenu( options, this ) );
				}
			});
		}
		return this;
	};

} )( $, window );